module.exports = __webpack_public_path__ + "static/img/score_5.e1ccce7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cage/score/score_5.jpg
// module id = gUYs
// module chunks = 0